import { type FC } from 'react';
import { MenuIcon, XIcon } from 'src/components/media-and-icons/icons';
import { Logo } from 'src/components/media-and-icons/logo';
import { cn } from 'src/utils/cn';

export const TopBar: FC<{
  open: boolean;
  // no toggle during loading
  setOpen?: (open: boolean) => void;
}> = ({ open, setOpen }) => {
  return (
    <div
      className={`
        flex h-5xl items-center bg-background-sidebar-default p-xl
        px-[calc(var(--spacing-xl)+var(--spacing-lg))]
        md:hidden
      `}
    >
      <div className="flex items-center gap-lg">
        <button
          onClick={() => setOpen?.(!open)}
          className={cn(
            'h-2xl w-2xl text-foreground-sidebar-subdued',
            !setOpen && 'invisible'
          )}
          aria-label="Toggle Navigation"
          disabled={!setOpen}
        >
          {open ? <XIcon size="md" /> : <MenuIcon size="md" />}
        </button>

        <Logo className="h-auto w-[96px]" />
      </div>
    </div>
  );
};
